export const initialState = {
    loader: false,
    loaderLong: false,
    user:'',
    modalData: {
        position:false
    },
    languages:[],
    mainSliders:[],
    companyAbout:'',
    costumers:[],
    costumerReviews:[],
    counterData:[],
    founderData:'',
    whyUs:[],
    aboutData:"",
    companyVAbout:"",
    contents:[],
    services:[],
    blogs:[],
    serviceCategories:[],
    videosData:[],

    categoryData:[],
    subCategoryData:[],
    productsData:[],
    subCategoryDataFilter:[],
    vservices:[]
}
